import { useState } from "react";

export function useTabsBehavior<T>(defaultValue?: T) {
  const [activeTab, setActiveTab] = useState<T | undefined>(defaultValue);

  const onTabChange = (value: T) => {
    setActiveTab(value);
  };

  return {
    defaultValue,
    activeTab,
    changeActiveTab: onTabChange,
  };
}
